export default __webpack_public_path__ + "static/terminal_explanation-9930cd43787d903f3d970c37155bbbf6.png";